export default __webpack_public_path__ + "static/media/Hail.1ccfdc01.mp4";